import React, { useState } from 'react'
import { AlertTypeEnums, ContactTypeEnums, AlertSettingsItem } from '../../common/constants'
import { NotificationTable } from './NotificationTable'

interface AlertSettingsSectionProps {
  advancedMode: boolean
  alertSettings: { [alertType: string]: { [key: string]: AlertSettingsItem | undefined } }
  onAlertSettingChange: (alertType: AlertTypeEnums, contactType: ContactTypeEnums, itemOrder: number, setting: Partial<AlertSettingsItem>) => void
  disabled?: boolean
}

export function AlertSettingsSection({ advancedMode, alertSettings, onAlertSettingChange, disabled }: AlertSettingsSectionProps) {
  const [selectedAlertType, setSelectedAlertType] = useState<AlertTypeEnums>(AlertTypeEnums.SENSOR_ALERTS)

  // Convert alertSettings structure to array for NotificationTable
  const getSettingsForAlertType = (alertType: AlertTypeEnums): AlertSettingsItem[] => {
    const typeSettings = alertSettings[alertType] || {}
    return Object.values(typeSettings).filter((s): s is AlertSettingsItem => s !== undefined)
  }

  const currentSettings = getSettingsForAlertType(selectedAlertType)

  return (
    <div className="bg-gray-50 rounded-lg p-6 border border-gray-200">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-medium text-gray-900">Email & SMS Notifications</h3>

        {/* Alert type dropdown - Advanced mode only */}
        {advancedMode && (
          <div className="flex items-center space-x-2">
            <label htmlFor="alert-type" className="text-sm text-gray-700">
              Alert Type:
            </label>
            <select
              id="alert-type"
              value={selectedAlertType}
              onChange={(e) => setSelectedAlertType(e.target.value as AlertTypeEnums)}
              disabled={disabled}
              className="px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <option value={AlertTypeEnums.SENSOR_ALERTS}>Sensor Alerts</option>
              <option value={AlertTypeEnums.SYSTEM_CONTROL_MESSAGES}>System Messages</option>
              <option value={AlertTypeEnums.TEST_MESSAGES}>Test Messages</option>
            </select>
          </div>
        )}
      </div>

      <p className="text-xs text-gray-600 mb-4">
        Configure up to 3 email addresses and 3 SMS numbers for {advancedMode ? 'each alert type' : 'sensor alerts'}.
      </p>

      <NotificationTable
        alertType={selectedAlertType}
        settings={currentSettings}
        onSettingChange={onAlertSettingChange}
        disabled={disabled}
      />
    </div>
  )
}
